/*
 * Sources:
 * - https://www.hcch.net/en/instruments/conventions/status-table/?cid=41
 * - https://www.iban.com/country-codes
 *
 * List of the numeric country codes of EU countries
 */

import { CountryKoodistoCode } from 'todistukset-common/src/vtj/vtj-koodisto.util'

export type CountryCodeType = { [key: string]: CountryKoodistoCode }

export const EuCountries: CountryCodeType = {
  AUSTRIA: '040',
  BELGIUM: '056',
  BULGARIA: '100',
  CROATIA: '191',
  CYPRUS: '196',
  CZECH_REPUBLIC: '203',
  DENMARK: '208',
  ESTONIA: '233',
  FINLAND: '246',
  FRANCE: '250',
  GERMANY: '276',
  GREECE: '300',
  HUNGARY: '348',
  IRELAND: '372',
  ITALY: '380',
  LATVIA: '428',
  LITHUANIA: '440',
  LUXEMBOURG: '442',
  MALTA: '470',
  NETHERLANDS: '528',
  POLAND: '616',
  PORTUGAL: '620',
  ROMANIA: '642',
  SLOVAKIA: '703',
  SLOVENIA: '705',
  SPAIN: '724',
  SWEDEN: '752',
}
